export class EmployeeVersionDetails {
  employeeNumber: number;
  platform: string = "Web";
  version: string;
}

export class EmployeeDetails {
  EmpNumber: string = "Web";
  EmployeeNumbers: Employee [] = [];
}

export class Employee {
  EmpNumber: string;
}